import ShowHideTabData from "../../../utils/showHideTabData";
import SocialHistortForm from "./components/SocialHistortForm";


export default function SocialHistory() {
   return (
    <>
        <ShowHideTabData TabFormData={SocialHistortForm}></ShowHideTabData>
    </>
   );
}
